<mat-form-field floatPlaceholder="always" floatLabel="always" appearance="outline" class="flex-1-1-100">
    <mat-label>State</mat-label>
    <div class="flex flex-row justify-start items-center">
        <mat-chip-listbox #chipList style="width: 90%">
            <mat-chip (removed)="remove(state)"
                      *ngFor="let state of selectedStateList"
                      [removable]="true"
                      [selectable]="true">
                {{ state?.stateName }}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input #stateInput
                   [formControl]="inputForm"
                   [matAutocomplete]="state"
                   [matChipInputAddOnBlur]="false"
                   [matChipInputFor]="chipList"
                   matInput
                   placeholder="Select State"
                   type="text"
            >
        </mat-chip-listbox>
        <button (click)="onAddState()" [disabled]="!possibleNewState" class="action-button add-to-fil-btn" mat-button>
            Add To
            State List
        </button>
    </div>
    <mat-autocomplete #state="matAutocomplete" (optionSelected)="selected($event)" [displayWith]="displayStateFn">
        <mat-option *ngFor="let state of stateFilteredOptions|async" [value]="state"
                    [disabled]="shouldDisableOption(state)">
            {{ state?.stateName }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
